<router-outlet></router-outlet>

<div id="error-display" [ngClass]="{ show: showError, hide: hideError }">
  <div class="error-heading">Oops!</div>
  <div>{{ errorMessage }}</div>
</div>
